import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isAdminEmail } from "../../admin/adminAccess";

export function AdminRoute({ children }) {
  const { user } = useAuth();
  const email = user?.email || "";

  if (!email) return <Navigate to="/home" replace />;
  if (!isAdminEmail(email)) return <Navigate to="/home" replace />;

  return children;
}
